import Link from "next/link";
import AppShell from "@/components/layout/AppShell";
import PageHeader from "@/components/ui/PageHeader";
import Button from "@/components/ui/Button";
import { TD, TH, THead } from "@/components/ui/Table";
import { prisma } from "@/lib/prisma";

export default async function ProductsPage() {
    let products: Array<{
        id: string;
        name: string;
        sku: string;
        category: string | null;
        sourceOrigin: string | null;
        status: string;
        coverImage: string | null;
        variants: Array<{ id: string }>;
    }> = [];

    let dbError: string | null = null;

    try {
        products = await prisma.product.findMany({
            include: { variants: true },
            orderBy: { createdAt: "desc" },
        });
    } catch (error) {
        dbError = error instanceof Error ? error.message : "Database connection failed.";
    }

    return (
        <AppShell>
            <PageHeader
                title="Products"
                description="Manage your dress catalog and variants."
                action={
                    <Link href="/products/new">
                        <Button>Add Product</Button>
                    </Link>
                }
            />

            {dbError ? (
                <div className="rounded-2xl border border-red-200 bg-red-50 p-4 text-sm text-red-700">
                    Database error: {dbError}
                </div>
            ) : (
                <div className="rounded-2xl border border-rose-100 bg-white shadow-soft overflow-x-auto">
                    <table className="min-w-full border-collapse">
                        <THead>
                            <tr>
                                <TH>Image</TH>
                                <TH>Name</TH>
                                <TH>SKU</TH>
                                <TH>Category</TH>
                                <TH>Origin</TH>
                                <TH>Status</TH>
                                <TH>Variants</TH>
                            </tr>
                        </THead>
                        <tbody>
                            {products.map((product) => (
                                <tr key={product.id} className="border-t border-rose-50">
                                    <TD>
                                        {product.coverImage ? (
                                            <img
                                                src={product.coverImage}
                                                alt={product.name}
                                                className="h-16 w-12 rounded-lg object-cover"
                                            />
                                        ) : (
                                            <div className="h-16 w-12 rounded-lg bg-rose-50" />
                                        )}
                                    </TD>
                                    <TD>{product.name}</TD>
                                    <TD>{product.sku}</TD>
                                    <TD>{product.category ?? "-"}</TD>
                                    <TD>{product.sourceOrigin ?? "-"}</TD>
                                    <TD>{product.status}</TD>
                                    <TD>{product.variants.length}</TD>
                                </tr>
                            ))}
                        </tbody>
                    </table>
                </div>
            )}
        </AppShell>
    );
}